mutation UserRankDelete($input: UserRankDeleteInput!) {
  userRankDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
